import { FC } from 'react';
import { CalendarIcon, cn } from '@fe-learner-common';
import {
  PhysicalEvent,
  TeleconferenceEvent,
  VirtualEvent,
} from './EventTypeGuards';
import { EventTags, TTag } from './Tags';
import { EventTexts } from './Event';
import { formatDateTimeRange } from '@fe-learner-common/utils/date';

type EventRowDetailsProps = {
  className?: string;
  texts: EventTexts;
  eventType: string;
  disabled: boolean;
  title: string;
  starts?: number | null;
  ends?: number | null;
  location?: string | null;
  pastEvent: boolean;
};
const Divider = () => (
  <span aria-hidden={true} className="text-body-md max-md:hidden">
    ·
  </span>
);

const EventRowDetails: FC<EventRowDetailsProps> = ({
  className,
  texts,
  eventType,
  disabled,
  title,
  starts,
  ends,
  location,
  pastEvent,
}) => {
  return (
    <div className={cn('flex gap-x-4', className)}>
      {starts ? (
        <CalendarIcon
          className="md:self-center"
          aria-hidden
          disabled={disabled}
          date={starts}
          size="md"
        />
      ) : null}
      <div className="flex flex-col items-start gap-1">
        <h4 className="text-label-lg">{title}</h4>
        <div className="flex flex-col flex-wrap items-start gap-2 text-left md:flex-row md:items-center ">
          {starts ? (
            <>
              <span className="sr-only">{texts.eventDate}</span>
              <span className="text-body-md capitalize text-neutral-500">
                {formatDateTimeRange(starts, ends)}
              </span>
            </>
          ) : null}
          <PhysicalEvent eventType={eventType} condition={!!location}>
            <>
              <Divider />
              <span className="text-body-md text-neutral-500">{location}</span>
            </>
          </PhysicalEvent>
          <VirtualEvent eventType={eventType}>
            <>
              <Divider />
              <span className="text-body-md text-neutral-500">
                {texts.virtualEvent}
              </span>
            </>
          </VirtualEvent>
          <TeleconferenceEvent eventType={eventType}>
            <>
              <Divider />
              <span className="text-body-md text-neutral-500">
                {texts.phoneConferenceEvent}
              </span>
            </>
          </TeleconferenceEvent>
          {pastEvent && (
            <>
              <Divider />
              <EventTags
                tags={[{ pastEvent: '' }] as TTag[]}
                texts={texts.tags}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventRowDetails;
